import { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import { Recepit, TransactionMinus } from "../../_components/Imagepath";
import { Table } from "antd";
import { onShowSizeChange } from "../../_components/paginationfunction";
import "../../_components/antd.css";
import { Link } from "react-router-dom";
import useCustomerHook from "./useCustomerHook";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useInvoiceHook from "../../sales/invoices/useInvoice";

const CustomerDetails = () => {
  const { FetchSingleCustomer } = useCustomerHook();
  const { FetchCustomerInvoiceDetails } = useInvoiceHook();
  const company = window.COMPANY;
  const { uuid } = useParams();
  const { customer } = FetchSingleCustomer(uuid);
  const { invoice } = FetchCustomerInvoiceDetails(uuid);
  console.log("customer ", customer, invoice);
  const [menu, setMenu] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const datasource = invoice?.invoices || [];

  const columns = [
    {
      title: "Invoice ID",
      dataIndex: "invoice_number",
      sorter: (a, b) => a.Invoice.length - b.Invoice.length,
      render: (text, record) => (
        <a
          onClick={() => {
            window.location.href = `/invoice/${record.id}/invoice`;
          }}
          className="invoice-link"
        >
          #{text}
        </a>
      ),
    },

    {
      title: "Created On",
      dataIndex: "created_on",
      sorter: (a, b) => new Date(a.created_on) - new Date(b.created_on),
    },
    {
      title: "Total Amount",
      dataIndex: "total_invoice_amount",
      sorter: (a, b) => a.total_invoice_amount - b.total_invoice_amount,
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (status, row) => (
        <>
          <div className="dropdown dropdown-action">
            <Link
              to="#"
              className=" btn-action-icon "
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-end customer-dropdown">
              <ul>
                <li>
                  <Link
                    className="dropdown-item"
                    to={`/invoice/${row.id}/edit/`}
                  >
                    <i className="far fa-edit me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to={`/invoice/${row.id}/invoice/`}
                  >
                    <i className="far fa-eye me-2" />
                    View
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="">
                    <i className="fe fe-download me-2" />
                    Download
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
      sorter: (a, b) => a.Action.length - b.Action.length,
    },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content customer-details container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header">
                <h5>Customer Details</h5>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card customer-details-group">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <i className="fe fe-hash"></i>
                        </span>
                        <div className="customer-details-cont">
                          <h6>Customer ID</h6>
                          <p>{customer?.customer_code || "-"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <i className="fa-solid fa-circle-user"></i>
                        </span>
                        <div className="customer-details-cont">
                          <h6>Customer Name</h6>
                          <p>{customer?.user?.full_name}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <i className="fe fe-mail"></i>
                        </span>
                        <div className="customer-details-cont">
                          <h6>Email Address</h6>
                          <p>{customer?.user?.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <i className="fe fe-phone"></i>
                        </span>
                        <div className="customer-details-cont">
                          <h6>Phone Number</h6>
                          <p>{customer?.user?.mobile_number || "-"}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <i className="fe fe-briefcase"></i>
                        </span>
                        <div className="customer-details-cont">
                          <h6>Customer Address</h6>
                          <p>
                            {customer?.billing_address?.address_line1},{" "}
                            {customer?.billing_address?.city},{" "}
                            {customer?.billing_address?.country}{" "}
                            {customer?.billing_address?.pincode}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <img src={TransactionMinus} alt="" />
                        </span>
                        <div className="customer-details-cont">
                          <h6>Total Invoices</h6>
                          <p>{invoice?.total_invoices}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <img src={Recepit} alt="" />
                        </span>
                        <div className="customer-details-cont">
                          <h6>Total Invoices Amount</h6>
                          <p className="success">
                            {company?.currency_symbol} {invoice?.total_value}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <img src={TransactionMinus} alt="" />
                        </span>
                        <div className="customer-details-cont">
                          <h6>Lead Stage</h6>
                          <p className="success">{customer?.lead_stage || '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                    <div className="customer-details">
                      <div className="d-flex align-items-center">
                        <span className="customer-widget-icon d-inline-flex">
                          <img src={TransactionMinus} alt="" />
                        </span>
                        <div className="customer-details-cont">
                          <h6>Lead Source</h6>
                          <p className="success">{customer?.source || '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card-table">
                  <div className="card-body">
                    <div className="table-responsive table-hover customer-details table-striped">
                      <Table
                        //  className="table table-stripped table-hover datatable"
                        pagination={{
                          total: datasource.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onShowSizeChange: onShowSizeChange,
                        }}
                        rowKey={(record) => record.id}
                        columns={columns}
                        dataSource={datasource}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Table */}
            {/* Delete Items Modal */}
            <div
              className="modal custom-modal fade"
              id="delete_modal"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="form-header">
                      <h3>Delete Customer Details</h3>
                      <p>Are you sure want to delete?</p>
                    </div>
                    <div className="modal-btn delete-action">
                      <div className="row">
                        <div className="col-6">
                          <Link
                            to="#"
                            data-bs-dismiss="modal"
                            className="btn btn-primary paid-continue-btn"
                          >
                            Delete
                          </Link>
                        </div>
                        <div className="col-6">
                          <Link
                            to="#"
                            data-bs-dismiss="modal"
                            className="btn btn-primary paid-cancel-btn"
                          >
                            Cancel
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Delete Items Modal */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerDetails;
